import { useTranslation } from 'react-i18next';

type BbtInfoModalProps = {
  isOpen: boolean;
  furnaceDeepLink: string | null;
  onClose: () => void;
  onOpenPurchase: () => void;
};

export default function BbtInfoModal({
  isOpen,
  furnaceDeepLink,
  onClose,
  onOpenPurchase,
}: BbtInfoModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const furnaceVideo = (
    <video
      className="bbt-info-furnace-video"
      src="https://hmseykssvtyrihuxymeo.supabase.co/storage/v1/object/public/bbt/mp4/bbt_furance.mp4"
      autoPlay
      muted
      loop
      playsInline
    />
  );

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section className="bbt-info-modal" role="dialog" aria-modal="true" aria-label={t('bbt.title')}>
        <div className="modal-header modal-header-close-only">
          <button className="modal-close-button" type="button" onClick={onClose} aria-label={t('bbt.close')}>
            ×
          </button>
        </div>

        <div className="bbt-info-content">
          <div className="bbt-info-identity">
            <img className="bbt-info-logo" src="/image/logo/bbtcoin_newlogo.png" alt="BBT logo" />
            <div>
              <strong>{t('bbt.tokenName')}</strong>
            </div>
          </div>

          <p className="bbt-info-description">{t('bbt.description')}</p>
          <p className="bbt-info-closing"><strong>{t('bbt.closing')}</strong></p>

          <div className="bbt-info-link-panel">
            <div>
              <p className="bbt-info-link-label">{t('bbt.furnaceTitle')}</p>
              <p className="bbt-info-link-description">{t('bbt.furnaceDescription')}</p>
            </div>
            {furnaceDeepLink ? (
              <a
                className="bbt-info-furnace-link"
                href={furnaceDeepLink}
                aria-label={t('bbt.furnaceVideoLinkLabel')}
              >
                {furnaceVideo}
              </a>
            ) : (
              <>
                {furnaceVideo}
                <p className="bbt-info-link-unavailable">{t('bbt.deepLinkNotConfigured')}</p>
              </>
            )}
          </div>

          <div className="bbt-info-actions">
            <button className="auth-button" type="button" onClick={onOpenPurchase}>
              {t('bbt.buyBbt')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
